{
  "eyebrow": "İçeridesiniz",
  "title": "Done-it'e hoş geldiniz, {{company}}.",
  "titleGeneric": "Done-it'e hoş geldiniz.",
  "sub": "{{plan}} için 30 günlük denemeniz etkin. Üç sonraki adım.",
  "subGeneric": "Hesabınız aktif. Sırada üç şey var.",
  "next1": {
    "title": "Mobil uygulamayı indirin",
    "desc": "Ekibinize kurulum bağlantısını SMS veya e-posta ile gönderin.",
    "cta": "Davet bağlantısı gönder"
  },
  "next2": {
    "title": "Ekibinizi davet edin",
    "desc": "Çalışanları toplu CSV içe aktarımı ile veya tek tek ekleyin.",
    "cta": "Yönetimi aç"
  },
  "next3": {
    "title": "4 dakikalık tanıtımı izleyin",
    "desc": "İlk projenizi ve konumlarınızı nasıl kuracağınızı öğrenin.",
    "cta": "Videoyu izle"
  },
  "cta": "Panele git",
  "receipt": "Bir makbuz ve karşılama e-postası {{email}} adresine yolda.",
  "receiptGeneric": "Bir makbuz ve karşılama e-postası yolda.",
  "fallbacks": {
    "company": "şirketin",
    "plan": "planın",
    "inbox": "gelen kutun"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "{{plan}} hesabınız aktif — sonsuza dek ücretsiz. Sırada üç şey var."
}
